'use strict';
var isConstructor = require('../internals/is-constructor');
var tryToString = require('../internals/try-to-string');

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw new $TypeError(tryToString(argument) + ' is not a constructor');
};



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/a-constructor.js
// module id = 458
// module chunks = 0